// src/components/chat/sections/dailyOutfit/RegisterSteps.js
import React, { useState } from 'react';

const RegisterSteps = ({
    stage = 0,
    email,
    setEmail,
    handleEmailSubmit,
    handleGenderClick,
    handleStyleClick,
    handleCityClick,
    handleColorClick = () => {}, // Add default empty function to prevent errors
    betaError
}) => {
    const [isValid, setIsValid] = useState(null);
    const [isFocused, setIsFocused] = useState(false);

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        if (value && !isFocused) {
            setIsValid(validateEmail(value));
        } else {
            setIsValid(null);
        }
    };

    const handleSubmit = () => {
        if (validateEmail(email)) {
            if (typeof handleEmailSubmit === 'function') {
                handleEmailSubmit();
            } else {
                console.error('handleEmailSubmit is not a function');
            }
        } else {
            setIsValid(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    // Safe wrapper functions to prevent errors
    const safeHandleGenderClick = (gender) => {
        if (typeof handleGenderClick === 'function') {
            handleGenderClick(gender);
        } else {
            console.error('handleGenderClick is not a function');
        }
    };

    const safeHandleStyleClick = (style) => {
        if (typeof handleStyleClick === 'function') {
            handleStyleClick(style);
        } else {
            console.error('handleStyleClick is not a function');
        }
    };

    const safeHandleCityClick = (city) => {
        if (typeof handleCityClick === 'function') {
            handleCityClick(city);
        } else {
            console.error('handleCityClick is not a function');
        }
    };

    const safeHandleColorClick = (colors) => {
        if (typeof handleColorClick === 'function') {
            handleColorClick(colors);
        } else {
            console.error('handleColorClick is not a function');
        }
    };

    if (stage >= 5) return null;

    return (
        <>
            {stage === 0 && (
                <div className="email-section">
                    <div className="email-section-header">
                        <h3 className="email-section-title">Welcome to Style Forecast</h3>
                        <p className="email-section-subtitle">
                            Enter your email to get personalized outfit suggestions
                        </p>
                    </div>
                    
                    <div className={`email-input-container ${
                        isValid === true ? 'valid' : isValid === false ? 'invalid' : ''
                    }`}>
                        <span className="email-icon">✉️</span>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={handleEmailChange}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => {
                                setIsFocused(false);
                                if (email) {
                                    setIsValid(validateEmail(email));
                                }
                            }}
                            onKeyPress={handleKeyPress}
                        />
                    </div>

                    {isValid === false && (
                        <div className="error-message">
                            <span>⚠️</span>
                            <span>Please enter a valid email address</span>
                        </div>
                    )}
                    
                    {betaError && (
                        <div className="beta-error-message">
                            <span>🔒</span>
                            <span>
                                We're currently running a closed beta test with our first focus group. 
                                <a href="https://docs.google.com/forms/d/e/1FAIpQLSeJqYz6Trne1TeeoP5shfFnPGJVAeDg6XPgHi98hkKnLQciWg/viewform?usp=header" 
                                   target="_blank" 
                                   rel="noopener noreferrer"
                                   className="beta-signup-link">
                                    Sign up for our second group
                                </a> 
                                which will start very soon!
                            </span>
                        </div>
                    )}

                    <button 
                        className="email-button"
                        onClick={handleSubmit}
                        disabled={email === '' || isValid === false}
                    >
                        <span>Continue</span>
                        <span className="button-icon">→</span>
                    </button>
                </div>
            )}

            {stage === 1 && (
                <div className="gender-buttons">
                    <button onClick={() => safeHandleGenderClick('Male')}>Male</button>
                    <button onClick={() => safeHandleGenderClick('Female')}>Female</button>
                </div>
            )}

            {stage === 2 && (
                <div className="style-buttons">
                    <button onClick={() => safeHandleStyleClick('Casual')}>Casual</button>
                    <button onClick={() => safeHandleStyleClick('Retro')}>Retro</button>
                    <button onClick={() => safeHandleStyleClick('Exotic')}>Exotic</button>
                    <button onClick={() => safeHandleStyleClick('Sporty')}>Sporty</button>
                </div>
            )}

            {stage === 3 && (
                <div className="city-buttons">
                    <button onClick={() => safeHandleCityClick('New York')}>New York</button>
                    <button onClick={() => safeHandleCityClick('Chicago')}>Chicago</button>
                    <button onClick={() => safeHandleCityClick('Houston')}>Houston</button>
                    <button onClick={() => safeHandleCityClick('Los Angeles')}>Los Angeles</button>
                </div>
            )}

            {stage === 4 && (
                <div className="color-buttons">
                    <button onClick={() => safeHandleColorClick('Black, White')}>Black, White</button>
                    <button onClick={() => safeHandleColorClick('Orange, White')}>Orange, White</button>
                    <button onClick={() => safeHandleColorClick('Olive, White')}>Olive, White</button>
                    <button onClick={() => safeHandleColorClick('Blue, Black')}>Blue, Black</button>
                </div>
            )}
        </>
    );
};

export default RegisterSteps;